import { render, staticRenderFns } from "./GeoTargetting.vue?vue&type=template&id=b7d6483c&"
import script from "./GeoTargetting.vue?vue&type=script&lang=ts&"
export * from "./GeoTargetting.vue?vue&type=script&lang=ts&"
import style0 from "./GeoTargetting.vue?vue&type=style&index=0&id=b7d6483c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports